module.exports = __webpack_public_path__ + "4a6f255fb04e94f375a5be798a02b941.fbx";